const playerPropsConfig = {
  hcDisabledList: [1234, 1236, 1237, 1238],
};

export default playerPropsConfig;